module.exports = __webpack_public_path__ + "img/subBan04.1bcb46a3.jpg";